import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import LogoImg from '../images/morecharz-logo.webp'
import { getUserDisplayName } from '../utils/userDisplay.js'
import './Header.css'

function Header({ user, onLogout }) {
  const navigate = useNavigate()
  const location = useLocation()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [avatarLoadFailed, setAvatarLoadFailed] = useState(false)
  const isLoggedIn = Boolean(user)

  // Scroll to top when route changes
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  useEffect(() => {
    setAvatarLoadFailed(false)
  }, [user?.avatarUrl])

  const handleLogout = () => {
    onLogout()
    navigate('/')
    setMobileMenuOpen(false)
  }

  const handleSearch = (e) => {
    e.preventDefault()
    // Add search functionality here
    console.log('Search query:', searchQuery)
    setSearchQuery('')
  }

  const handleNavClick = () => {
    setMobileMenuOpen(false)
    window.scrollTo(0, 0)
  }

  const handleSignIn = () => {
    setMobileMenuOpen(false)
    navigate('/', { state: { openAuth: true, authRequest: Date.now() } })
  }

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo-section">
            <Link to="/" className="logo-link" onClick={handleNavClick}>
              <img src={LogoImg} alt="MoRecharz" className="logo-img" />
            </Link>
          </div>

          <div className="search-section">
            <form className="search-form" onSubmit={handleSearch}>
              <span className="material-icons search-icon">search</span>
              <input 
                type="text" 
                className="search-input" 
                placeholder="Search operators, plans..." 
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </form>
          </div>

          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="material-icons">menu</span>
          </button>

          <nav className={`nav ${mobileMenuOpen ? 'active' : ''}`}>
            <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={handleNavClick}>
              <span className="material-icons">home</span>
              Home
            </Link>
            <Link to="/products" className={`nav-link ${location.pathname.startsWith('/products') ? 'active' : ''}`} onClick={handleNavClick}>
              <span className="material-icons">local_offer</span>
              Recharge Plans
            </Link>
            <Link to="/about" className={`nav-link ${location.pathname.startsWith('/about') ? 'active' : ''}`} onClick={handleNavClick}>
              <span className="material-icons">info</span>
              About Us
            </Link>
            {!isLoggedIn && (
              <Link type="button" className="nav-link" onClick={handleSignIn}>
                <span className="material-icons">account_circle</span>
                Sign in
              </Link>
            )}
            {isLoggedIn && (
              <div className="user-section">
                <Link to="/profile" className={`nav-link ${location.pathname === '/profile' ? 'active' : ''}`} onClick={handleNavClick}>
                  {user.avatarUrl && !avatarLoadFailed ? (
                    <img
                      src={user.avatarUrl}
                      alt=""
                      className="header-user-avatar"
                      onError={() => setAvatarLoadFailed(true)}
                    />
                  ) : (
                    <span className="material-icons">account_circle</span>
                  )}
                  {getUserDisplayName(user, 'Logged in')}
                </Link>
                <button
                  type="button"
                  className="btn-logout-link"
                  onClick={handleLogout}
                  aria-label="Logout"
                  title="Logout"
                >
                  <span className="material-icons">logout</span>
                </button>
              </div>
            )}
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
